<template>
    <div class="main-container">
        <!-- navbar -->
        <div class="row mx-0 py-3">
            <div class="col-md-12 col-sm-6 offset-sm-6 col-12 offset-md-0">
                <button class="btn btn-confirm float-right" @click="openUploadPricingMatrixModal">Upload Postcode Matrix</button>
            </div>
        </div>
        <div class="row mx-0 pb-1">
            <div class="col-md-12">
                <div class="float-right d-flex">
                    <strong>Show All My Offers</strong>
                    <label class="switch selected">
                        <input type="checkbox" class="on-off-toggler" v-model="toggleAllOffers" @click="switchDayAvailabilityStatus('ALL')">
                        <span class="slider round lg"></span>
                    </label>
                    <strong>{{toggleAllOffers ? 'On' : 'Off'}}</strong>
                </div>
            </div>
        </div>

        <div class="row mx-0 py-1">
            <div class="col-md-12">
                <h1 class="heading-medium mt-3" ><i class="fas fa-chart-line mr-2"></i>Manage Terminals</h1>
                <h2 v-if="$breakpoint.mdAndDown " class="heading-small mt-4 mb-0">Set availabilitiy times and status</h2>
            </div>
        </div>

        <div class="row mx-0">
            <div 
                class="col-md-12"
                :class="{'px-0' : !$breakpoint.lgAndDown}"
            >
                <div class="table-container">
                    <table class="table responsive-table">
                        <thead class="thead-light" v-if="!$breakpoint.lgAndDown">
                            <tr>
                                <th width="25%">Time <em>(24hr format)</em></th>
                                <th width="20%">
                                    <button style="min-width: 140px;" class="btn btn-actionable" @click="saveTimes" :disabled="invalidTimesFound">
                                        Confirm availabilitiy
                                    </button>
                                    <span class="hidden error-message"
                                        :class="[{'error-message-popup': invalidTimesFound}]">
                                        Closing time must be later than opening time
                                    </span>
                                </th>
                                <th width="5%"></th>
                                <th width="10%" v-for="(day, key) in dayAvailabilityStatusList" :key="key">
                                    <div 
                                        class="d-flex align-items-center"
                                        :class="{'flex-column' : $breakpoint.xlAndDown}"
                                    >
                                        <input 
                                            class='start-time-input w-85px'
                                            :class="{'mr-2': !$breakpoint.xlAndDown }"
                                            type="time" Min="1:00" Max="24:00"  v-model="day.start">
                                        &ndash;
                                        <input 
                                            class='end-time-input w-85px' 
                                            :class="{'ml-2': !$breakpoint.xlAndDown }"
                                            type="time" Min="1:00" Max="24:00" v-model="day.end">
                                    </div>
                                </th>
                            </tr>
                            <tr>
                                <th>Day availability status</th>
                                <th></th>
                                <th></th>
                                <th v-for="(day, key) in dayAvailabilityStatusList" :key="key">
                                    <div class="d-flex align-items-center justify-content-center">
                                        <span class="switch-value" :class="{'selected': !day.enabled && !disabledAllOffersPerDay[key] && toggleAllOffers}">Off</span>
                                        <label class="switch selected">
                                            <input type="checkbox" class="on-off-toggler" v-model="day.enabled" :disabled="disabledAllOffersPerDay[key] || !toggleAllOffers"
                                                @click="switchDayAvailabilityStatus(key)">
                                            <span class="slider round"></span>
                                        </label>
                                        <span class="switch-value" :class="{'selected': day.enabled && !disabledAllOffersPerDay[key] && toggleAllOffers}">On</span>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <thead class="thead-light thead-action" v-else>                   
                            <tr class="py-2" v-for="(day, key) in dayAvailabilityStatusList" :key="key">
                                <th class="heading-medium px-2">
                                    {{daysList[key] | daydateformat}}
                                </th>
                                <td label="Time (24hr format)" class="px-2">
                                    <span 
                                        class="d-flex align-items-center justify-content-end"
                                    >
                                        <input 
                                            class='start-time-input'
                                            :class="[$breakpoint.xsOnly ? 'w-70px p-1' : 'w-85px', {'mr-2': !$breakpoint.xlAndDown }]"
                                            @blur="saveTimes"
                                            type="time" Min="1:00" Max="24:00"  v-model="day.start">
                                        &ndash;
                                        <input 
                                            class='end-time-input' 
                                            :class="[$breakpoint.xsOnly ? 'w-70px p-1' : 'w-85px', {'mr-2': !$breakpoint.xlAndDown }]"
                                            @blur="saveTimes"
                                            type="time" Min="1:00" Max="24:00" v-model="day.end">
                                    </span>
                                </td>
                                <td label="Day availability status" class="px-2">
                                    <span class="d-flex  align-items-center justify-content-end">
                                        <span class="switch-value" :class="{'selected': !day.enabled && !disabledAllOffersPerDay[key] && toggleAllOffers}">Off</span>
                                        <label class="switch selected">
                                            <input type="checkbox" class="on-off-toggler" v-model="day.enabled" :disabled="disabledAllOffersPerDay[key] || !toggleAllOffers"
                                                @click="switchDayAvailabilityStatus(key)">
                                            <span class="slider round"></span>
                                        </label>
                                        <span class="switch-value" :class="{'selected': day.enabled && !disabledAllOffersPerDay[key] && toggleAllOffers}">On</span>
                                    </span>
                                </td>
                            </tr>
                        </thead>

                        <!-- Main table -->
                        <thead>
                            <tr>
                                <th>Terminal</th>
                                <th>Active Offers</th>
                                <th></th>
                                <th v-for="(day, dayIndex) in daysList" :key="dayIndex">
                                    {{day | daydateformat}}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if = "terminalSettings.length === 0">
                                <td colspan="8"> 
                                    <b> Upload file to see terminals </b>
                                </td>
                            </tr>
                            <tr 
                                v-else v-for="(terminal, key) in terminalSettings" :key="key"
                                class="offer-rows"
                                :class="{'py-2': $breakpoint.mdAndDown}"
                            >
                                <th 
                                    :class="{'heading-medium' : $breakpoint.mdAndDown}"
                                >
                                    {{terminal.terminal.name}}
                                </th>
                                <td label="Active Offers">
                                    <span>{{terminal.offersAvailable}}</span>
                                </td>
                                <td label="On/Off">
                                    <span 
                                        class="d-flex align-items-center"
                                        :class="[$breakpoint.mdAndDown ? 'justify-content-end' : 'justify-content-center' ]"
                                    >
                                        <span class="switch-value" :class="{'selected': !terminal.enabled && toggleAllOffers}">Off</span>
                                            <label class="switch selected">
                                                <input type="checkbox" class="on-off-toggler" v-model="terminal.enabled" 
                                                    :disabled="(terminal.terminal.status && terminal.terminal.status !== '100') || !toggleAllOffers"
                                                    @click="switchTerminalAvailabilityStatus(terminal.terminal_id, 'ALL', !terminal.enabled)">
                                                <span class="slider round"></span>
                                            </label>
                                        <span class="switch-value" :class="{'selected': terminal.enabled && toggleAllOffers}">On</span>
                                    </span>
                                </td>
                                <td :label="daysList[dayIndex] | daydateformat" v-for="(day, dayIndex) in terminalSettingsPerDay[key]" :key="dayIndex">
                                    <span 
                                        class="d-flex align-items-center"
                                        :class="[$breakpoint.mdAndDown ? 'justify-content-end' : 'justify-content-center' ]"
                                    >
                                        <span class="switch-value" 
                                            :class="{'selected': !day.enabled && terminal.enabled && dayAvailabilityStatusList[dayIndex].enabled && !disabledAllOffersPerDay[dayIndex] && toggleAllOffers}">Off</span>
                                            <label class="switch selected">
                                                <input type="checkbox" class="on-off-toggler" v-model="day.enabled" 
                                                    :disabled="(terminal.terminal.status && terminal.terminal.status !== '100') || !terminal.enabled || !dayAvailabilityStatusList[dayIndex].enabled || disabledAllOffersPerDay[dayIndex] || !toggleAllOffers"
                                                    @click="switchTerminalAvailabilityStatus(terminal.terminal_id, dayIndex, !day.enabled)">
                                                <span class="slider round"></span>
                                            </label>
                                        <span class="switch-value" 
                                            :class="{'selected': day.enabled && terminal.enabled && dayAvailabilityStatusList[dayIndex].enabled && !disabledAllOffersPerDay[dayIndex] && toggleAllOffers}">On</span>
                                    </span>
                                </td>
                            </tr>  
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div class="row bg-white mx-0 py-1">
            <div class="col-md-12">
                <h1 class="heading-medium mt-5"><i class="fas fa-chart-line mr-2"></i>My Delivered In Offers</h1>
            </div>
        </div>

        <div class="table-container">
            <div class="row py-3 mx-0">
                <div 
                    class="d-flex col-xl-3 col-md-4 col-sm-5 col-xs-12"
                    :class="[$breakpoint.xsOnly ? 'justify-content-between mb-2' : 'justify-content-start' ]"
                >
                    <label class="mr-2 mb-0 mt-2 text-nowrap" for="select-fuel-type">Filter by:</label>
                    <el-select
                        v-model="filtersSelected.fuel_id"
                        value-key="_id"
                        placeholder="Select a Fuel"
                    >
                        <el-option
                        v-for="(fuel, index) in fuelTypeList"
                        :key="index"
                        :label="fuel.name"
                        :value="fuel._id"
                        >
                        </el-option>
                    </el-select>
                    <span class="hidden error-message"
                        :class="[{'error-message-popup': errorFound == 'FUEL'}]">
                        {{errorMessages.fuel}}
                    </span>
                </div>

                <div 
                    class="col-xl-5 col-md-12 col-sm-12 col-12 d-flex align-items-start justify-content-end"
                    :class="{'order-3 mt-2' : $breakpoint.lgAndDown && !$breakpoint.xsOnly, 'mb-2' : $breakpoint.xsOnly}"
                >
                    <button v-for="(day, dayIndex) in daysList" :key="dayIndex" class="btn day-selection"
                        :class="[filtersSelected.days.includes(day) ? 'btn-neutral' : 'btn-outline-t_grey', {'ml-2' : dayIndex !== 0 }, {'p-1': $breakpoint.xsOnly}]"
                        @click="selectDay(day)">
                        {{day | daydateformat}}
                    </button>
                    <span class="hidden error-message"
                        :class="[{'error-message-popup': errorFound == 'DAYS'}]">
                        {{errorMessages.days}}
                    </span>
                </div>

                <div 
                    class=" d-flex col-xs-12 col-xl-4 col-md-8 col-sm-7"
                    :class="[ $breakpoint.xsOnly ?  'justify-content-between flex-column' : 'pl-0 justify-content-end' ]"
                >
                    <label for="search-postcode" class="mr-2 mb-0 mt-2">Postcode:</label>
                    <input 
                        class="search-bar"
                        :class="{'mr-2' : !$breakpoint.xsOnly}"
                        id="search-postcode" type="text" placeholder="Input Postcode..." v-model="filtersSelected.postcode"
                        maxlength="4" @keydown.space.prevent>
                    <span class="hidden error-message"
                        :class="[{'error-message-popup': errorFound == 'POSTCODE'}]">
                        {{errorMessages.postcode}}
                    </span>
                    <button 
                        :class="{'mt-2' : $breakpoint.xsOnly}"
                        class="btn btn-actionable submit-filter" @click="confirmFilters()">Submit</button>
                </div>
            </div>
            <div v-if="filteredHaulageList.length < 1"
                class="alert tables-alert-custom-message-notify mt-3 text-center">
                <i class="fas fa-info-circle mr-2"></i>
                <span v-if="!showFilteredResult">Please select filters</span>
                <span v-else>No haulage found</span>
            </div>
            <table v-else class="table responsive-table">
                <thead v-if="filteredHaulageList.length > 0">
                    <tr>
                        <th>Buyer Postcode</th>
                        <th>Selling Terminal</th>
                        <th>Delivery Date</th>
                        <th>Available</th>
                        <th>Ex-rack (ppl)</th>
                        <th>Haulage (ppl)</th>
                        <th>Delivered Price (ppl)</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(haulage, key) in filteredHaulageList" :key="key">
                        <td label="Buyer Postcode">
                            {{haulage.postCode}}
                        </td>
                        <td label="Selling Terminal">
                            {{haulage.terminal.name}} 
                        </td>
                        <td label="Delivery Date">
                            {{haulage.deliveryDate | daydateformat}}
                        </td>
                        <td label="Available">
                            {{haulage.available ? 'Yes' : 'No'}}
                        </td>
                        <td label="Ex-rack (ppl)">
                            {{haulage.offerPrice | priceformat}}
                        </td>
                        <td label="Haulage (ppl)">
                            {{haulage.dayDeliveryPpl | priceformat}}
                        </td>
                        <td label="Total (£)">
                            {{haulage.offerPrice + haulage.dayDeliveryPpl | priceformat}}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import {mapState,mapActions,mapGetters} from 'vuex';
import breakpoint from '@/mixins/index';
import moment from 'moment';

export default {
    mixins: [breakpoint],
    data: function(){
        return {
            toggleAllOffers: false,
            dayAvailabilityStatusList: [],
            terminalSettingsPerDay: [],
            filtersSelected: {
                fuel_id: null,
                days: [],
                postcode: null
            },
            filtersApplied: {
                fuel_id: null,
                days: [],
                postcode: null
            },
            showFilteredResult: false,
            errorFound: '',
            errorMessages: {
                fuel: 'Please select a product',
                days: 'Please select one or more delivery dates',
                postcode: 'Please enter the first 3/4 characters of a valid postcode'
            },
            filteredHaulageList: [],
            parsedAvailabilityTimes: [],
            timeParsed:false,
            timerForRefresh:0
        }
    },
    created(){
        /* Append the relevant data */
        this.getDinTerminals()
        this.toggleAllOffers = this.offersAvailability.deliveredIn.enabled
        this.dayAvailabilityStatusList.push(Object.assign({}, this.offersAvailability.deliveredIn.days['one']))
        this.dayAvailabilityStatusList.push(Object.assign({}, this.offersAvailability.deliveredIn.days['two']))
        this.dayAvailabilityStatusList.push(Object.assign({}, this.offersAvailability.deliveredIn.days['three']))
        this.dayAvailabilityStatusList.push(Object.assign({}, this.offersAvailability.deliveredIn.days['four']))
        this.dayAvailabilityStatusList.push(Object.assign({}, this.offersAvailability.deliveredIn.days['five']))

    },
    methods:{
        ...mapActions('sellerOffers', ['openUploadMatrixModal', 'setOffersTimeAvailability', 'toggleOffersAvailability',
            'getAllOffersForUser', 'getDinTerminals']),
        getDayIndex: function(dayIndex){
            switch (dayIndex){
                case 0:
                    return 'one'
                case 1:
                    return 'two'
                case 2:
                    return 'three'
                case 3:
                    return 'four'
                case 4:
                    return 'five'
            }
        },
        saveTimes(){
            const payload = {
                type: 'DELIVERED_IN',
                days: this.dayAvailabilityStatusList
            }

            this.setOffersTimeAvailability(payload)
        },
        switchDayAvailabilityStatus: function(key){
            const payload = {
                type: 'DELIVERED_IN',
                day: key,
                newStatus: key == 'ALL' ? 
                    !this.offersAvailability.deliveredIn.enabled : !this.dayAvailabilityStatusList[key].enabled
            }
            
            this.toggleOffersAvailability(payload)
        },
        switchTerminalAvailabilityStatus: async function(terminalId, index, newStatus){
            const payload = {
                haulierAccountId: this.userLoggedIn.id,
                terminalId: terminalId,
                index: index,
                newStatus: newStatus
            }

            const response = await this.axios.post('/api/switchTerminalAvailabilityStatus', payload)

            if (response.data.success){
                this.getAllOffersForUser()
            }
        },
        openUploadPricingMatrixModal(){
            this.openUploadMatrixModal()
        },
        selectDay: function(daySelected){
            if (this.filtersSelected.days.includes(daySelected)){
                const dayMatchIndex = this.filtersSelected.days.findIndex(day => day == daySelected)
                this.filtersSelected.days.splice(dayMatchIndex, 1)
            }
            else {
                this.filtersSelected.days.push(daySelected)
            }
        },
        confirmFilters: function(){
            const postcodeRegEx = /^(([A-Z][0-9]{1,2})|(([A-Z][A-HJ-Y][0-9]{1,2})|(([A-Z][0-9][A-Z])|([A-Z][A-HJ-Y][0-9]?[A-Z]))))$/

            if (this.filtersSelected.fuel_id == null){
                this.errorFound = 'FUEL'
                setTimeout(()=>{
                    this.errorFound = ''
                }, 2000)
            }
            else if (this.filtersSelected.days.length < 1){
                this.errorFound = 'DAYS'
                setTimeout(()=>{
                    this.errorFound = ''
                }, 2000)
            }
            else if (!postcodeRegEx.test(this.filtersSelected.postcode.toUpperCase())){
                this.errorFound = 'POSTCODE'
                setTimeout(()=>{
                    this.errorFound = ''
                }, 2000)
            }
            else {
                this.filtersApplied.fuel_id = this.filtersSelected.fuel_id
                this.filtersApplied.days = Object.assign([], this.filtersSelected.days)
                this.filtersApplied.postcode = this.filtersSelected.postcode
                this.errorFound = ''
                this.fetchFilteredHaulageList()
            }
        },
        fetchFilteredHaulageList: async function(){
            let fuelsIdList = []
            let daysSelected = []

            /* Put fuel IDs into a list (and add blended IDs if needed) */
            if (this.filtersApplied.fuel_id == this.productConfig.DieselId){ // Diesel
                fuelsIdList = [this.productConfig.DieselId, this.productConfig.BlendedDieselBioId]
            }
            else if (this.filtersApplied.fuel_id == this.productConfig.GasoilId){ // Gasoil
                fuelsIdList = [this.productConfig.GasoilId, this.productConfig.BlendedGasoilId]
            }
            else {
                fuelsIdList = [this.filtersApplied.fuel_id]
            }

            /* Re-format days selected here to safeguard against changes */
            this.filtersApplied.days.forEach((day, index) => {
                const matchingIndex = this.daysList.findIndex(matchingDay => matchingDay == day)
                daysSelected.push(matchingIndex + 1)
            })

            const payload = {
                accountId: this.userLoggedIn.id,
                postCode: this.filtersApplied.postcode.toUpperCase(),
                fuelsIds: fuelsIdList,
                deliveryDays: daysSelected
            }

            const response = await this.axios.get('/api/fetchFilteredHaulageList', {params: payload})
 
            if (response.data.success){ 
                this.filteredHaulageList = response.data.haulage
            }
            this.showFilteredResult = true
        },
        countdownForRefreshingToggles: function(){
            const now = Date.parse(new Date())
            const future = this.parsedAvailabilityTimes.filter(time => time > now);
            const min = Math.min.apply(null, future)
            const diff = (min - now) +2000
            this.timerForRefresh = setTimeout(() => { 
                this.timeParsed = true
            }, diff);             
        },
        formatStartTime: function(i){
            const dayIndex = this.getDayIndex(i);
            const startTime = moment(this.offersAvailability.deliveredIn.days[dayIndex].start, 'HHmm');
            return startTime;
        },
        formatEndTime: function(i){
            const dayIndex = this.getDayIndex(i)
            const endTime = moment(this.offersAvailability.deliveredIn.days[dayIndex].end, 'HHmm');
            return endTime;
        }
    },
    computed:{
        ...mapState('login', ['userLoggedIn']),
        ...mapState('sellerOffers',['liveOffersSeller', 'showUploadMatrix', 'offersAvailability', 'dinTerminals']),
        ...mapGetters('fuelsType', ['getFuelsType']),
        ...mapGetters('metadata', ['productConfig']),
        
        disabledAllOffersPerDay: {
            get: function(){
                this.parsedAvailabilityTimes= []
                let disabledStatuses = []
                const currentTime = moment();
                if (this.offersAvailability || this.timeParsed){
                    if (this.offersAvailability.deliveredIn.days){
                        for (let i = 0; i < Object.keys(this.offersAvailability.deliveredIn.days).length; i++){
                            const startTime = this.formatStartTime(i);
                            const endTime = this.formatEndTime(i)
                            this.parsedAvailabilityTimes.push(startTime)
                            this.parsedAvailabilityTimes.push(endTime)
                            if (currentTime.isBefore(startTime) || endTime.isSameOrBefore(currentTime)){
                                disabledStatuses[i] = true;
                            }
                            else {
                                disabledStatuses[i] = false;
                            }
                        }if(!this.timeParsed){
                        this.countdownForRefreshingToggles()
                        }else{
                            this.timeParsed=false
                        }
                    }
                }
                return disabledStatuses
            }
        },
        daysList: {
            get: function(){
                const moment = require('moment');
                const momentBusiness = require('moment-business-days');

                const today = moment().format('DD-MM-YYYY');
                let days = []

                days.push(momentBusiness(today, 'DD-MM-YYYY').businessAdd(1)._d)
                days.push(momentBusiness(today, 'DD-MM-YYYY').businessAdd(2)._d)
                days.push(momentBusiness(today, 'DD-MM-YYYY').businessAdd(3)._d)
                days.push(momentBusiness(today, 'DD-MM-YYYY').businessAdd(4)._d)
                days.push(momentBusiness(today, 'DD-MM-YYYY').businessAdd(5)._d)

                return days
            }
        },
        fuelTypeList: {
            get: function() {
                let fuels = []

                if (this.getFuelsType){
                    const filteredFuels = this.getFuelsType.filter(fuel => fuel.type === 'SPOT')
                    fuels.push(...filteredFuels)
                }

                return fuels
            }
        },
        terminalSettings: {
            get: function() {
                this.terminalSettingsPerDay = []
                let terminalSettings

                if (this.dinTerminals){
                    terminalSettings = this.dinTerminals
                    terminalSettings.forEach((terminal, index) => {
                        let arr = [ 
                            terminal.days['one'],
                            terminal.days['two'],
                            terminal.days['three'],
                            terminal.days['four'],
                            terminal.days['five'],
                        ]

                        this.terminalSettingsPerDay.push(arr)
                    })
                }
                
                return terminalSettings
            }
        },
        invalidTimesFound: {
            get: function(){
                let status = false

                if (this.dayAvailabilityStatusList){
                    const dayIndex = this.dayAvailabilityStatusList.findIndex(day => 
                        new Date().setHours(day.end.substring(0 ,2), day.end.substring(3)) <= 
                        new Date().setHours(day.start.substring(0, 2), day.start.substring(3)))
                    
                    if (dayIndex > -1)
                        status = true
                }

                return status
            }
        },
        openMatrixUploader(){
            if(this.showUploadMatrix){
                let element = this.$root.$refs.uploadMatrix.$el
                $(element).modal({backdrop: 'static', keyboard: false})
            }
            return 
        }
    },
    watch: {
        openMatrixUploader(){}
    },
    beforeDestroy() {
        clearTimeout(this.timerForRefresh)
    }
}
</script>


<style lang="scss" scoped>
</style>